var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppNavigationItem',{attrs:{"title":_vm.title},on:{"click":_vm.openUserSettings}},[_c('AlertCircleIcon',{attrs:{"slot":"icon","size":20,"decorative":""},slot:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }